export default __webpack_public_path__ + "assets/img/ict-upload-pdf.537accec7fa184a64efa9c9fb2c5dc7c.svg";